<template>
  <div>
    <Card class="full-height-card">
      <div slot="title">
        <Icon type="ios-list"></Icon>
        验布信息列表
      </div>
      <div slot="extra">
        <!-- 汇总信息 -->
        <div class="summary-info">
          <div class="summary-item">
            <span class="summary-label">总长度:</span>
            <span class="summary-value">{{ totalLengthMeters }}米</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">总长度:</span>
            <span class="summary-value">{{ totalLengthYards }}码</span>
          </div>
        </div>
        <Button @click="goBack" type="default" style="margin-left: 16px;">
          <Icon type="ios-arrow-back"></Icon>
          返回
        </Button>
      </div>
      
      <div class="card-body-flex">
        <!-- 搜索和筛选区域 -->
        <Row class="search-con" :gutter="16">
          <Col span="4">
            <Input v-model="batchNumber" placeholder="请输入缸号" clearable></Input>
          </Col>
          <Col span="4">
            <Input v-model="pieceNumber" placeholder="请输入匹号" clearable></Input>
          </Col>
          <Col span="6">
            <DatePicker 
              v-model="dateRange" 
              type="daterange" 
              placeholder="选择日期范围"
              format="yyyy-MM-dd"
              @on-change="onDateChange"
              clearable
            ></DatePicker>
          </Col>
          <Col span="2">
            <Button @click="handleSearch" type="primary">搜索</Button>
          </Col>
          <Col span="2">
            <Button @click="handleReset" type="default">重置</Button>
          </Col>
        </Row>

        <!-- 设备信息展示 -->
        <Row style="margin-bottom: 12px;" v-if="deviceInfo">
          <Col span="24">
            <Alert type="info" show-icon>
              <div slot="desc">
                <p><strong>机器端口:</strong> {{ deviceInfo.mac_address }}</p>
                <p><strong>所属工厂:</strong> {{ deviceInfo.factorName }}</p>
              </div>
            </Alert>
          </Col>
        </Row>

        <!-- 验布信息表格（可用空间自适应高度） -->
        <div class="table-flex">
          <tables 
            :columns="columns" 
            v-model="tableData" 
            :loading="tableLoading"
            :show-pagination="false"
          />
        </div>
        
        <!-- 分页 -->
        <Row class="page-con">
          <div class="page-bottom">
            <Page 
              :current="page" 
              :total="total" 
              :page-size="pageSize" 
              :page-size-opts="[10, 20, 50, 100]"
              show-sizer 
              show-elevator 
              @on-change="changePage"
              @on-page-size-change="changePageSize" 
            />
          </div>
        </Row>
      </div>
    </Card>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import { getLiveDeviceInfo } from "@/api/data";

export default {
  name: "inspection_info",
  components: {
    Tables,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      batchNumber: "", // 缸号
      pieceNumber: "", // 匹号
      dateRange: [],
      startDate: "",
      endDate: "",
      tableLoading: false,
      deviceInfo: null,
      tableData: [],
      columns: [
        { type: 'index', title: '序号', width: 80, align: "center" }
      ],
      dynamicColumns: [], // 动态生成的列
      totalLengthMeters: 0, // 总长度（米）
      totalLengthYards: 0 // 总长度（码）
    }
  },
  mounted() {
    this.initDeviceInfo();
    this.loadInspectionData();
  },
  methods: {
    initDeviceInfo() {
      // 从路由参数获取设备信息
      const query = this.$route.query;
      this.deviceInfo = {
        id: query.deviceId || '',
        mac_address: query.macAddress || '',
        type: query.type || '',
        factorName: query.factoryName || ''
      };
    },
    async loadInspectionData() {
      if (!this.deviceInfo.id) {
        this.$Message.error('设备ID不能为空');
        return;
      }

      this.tableLoading = true;
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          liveDeviceId: this.deviceInfo.id
        };

        // 添加缸号搜索
        if (this.batchNumber) {
          params.batch = this.batchNumber;
        }

        // 添加匹号搜索
        if (this.pieceNumber) {
          params.piece = this.pieceNumber;
        }

        // 添加日期筛选
        if (this.startDate) {
          params.startTime = this.startDate;
        }
        if (this.endDate) {
          params.endTime = this.endDate;
        }

        const response = await getLiveDeviceInfo(params);
        
        if (response.data.code === 200) {
          this.tableData = response.data.data.records || [];
          this.total = response.data.data.total || 0;
          
          // 计算总长度
          this.calculateTotalLength();
          
          // 动态生成表头
          this.generateDynamicColumns();
        } else {
          this.tableData = [];
          this.total = 0;
          this.$Message.error(response.data.msg || '获取验布信息失败');
        }
      } catch (error) {
        this.tableData = [];
        this.total = 0;
        this.totalLengthMeters = 0;
        this.totalLengthYards = 0;
        this.$Message.error('获取验布信息失败：' + (error.message || '网络错误'));
        console.error('获取验布信息失败:', error);
      } finally {
        this.tableLoading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.loadInspectionData();
    },
    handleReset() {
      this.batchNumber = "";
      this.pieceNumber = "";
      this.dateRange = [];
      this.startDate = "";
      this.endDate = "";
      this.page = 1;
      this.loadInspectionData();
    },
    onDateChange(dates) {
      if (dates && dates.length === 2) {
        this.startDate = dates[0];
        this.endDate = dates[1];
      } else {
        this.startDate = "";
        this.endDate = "";
      }
    },
    changePage(page) {
      this.page = page;
      this.loadInspectionData();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.page = 1;
      this.loadInspectionData();
    },
    viewDetail(row) {
      // 显示验布详情
      this.$Modal.info({
        title: `验布详情 - ID: ${row.id}`,
        width: 800,
        content: h('div', [
          h('div', { style: { marginBottom: '20px' } }, [
            h('h4', '基本信息'),
            h('p', `验布ID: ${row.id}`),
            h('p', `验布时间: ${row.createTime}`),
            h('p', `布料类型: ${row.fabricType || '未知'}`),
            h('p', `验布长度: ${row.length || 0}米`),
            h('p', `检测结果: ${row.result || '未知'}`),
            h('p', `疵点数量: ${row.defectCount || 0}个`),
            h('p', `验布状态: ${row.status || '未知'}`)
          ]),
          h('div', [
            h('h4', '详细信息'),
            h('pre', { 
              style: { 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '4px',
                maxHeight: '400px',
                overflow: 'auto',
                fontSize: '12px'
              } 
            }, JSON.stringify(row, null, 2))
          ])
        ])
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    calculateTotalLength() {
      let totalDist = 0; // 总距离（毫米）
      
      this.tableData.forEach(record => {
        try {
          const recordData = JSON.parse(record.checkClothInfo);
          const dist = recordData.dist || 0;
          totalDist += dist;
        } catch (e) {
          // 忽略解析失败的记录
        }
      });
      
      // 转换为米和码
      this.totalLengthMeters = (totalDist / 1000).toFixed(2);
      this.totalLengthYards = (totalDist / 914.4).toFixed(2);
    },
    generateDynamicColumns() {
      if (!this.tableData || this.tableData.length === 0) {
        this.columns = [{ type: 'index', title: '序号', width: 80, align: "center" }];
        return;
      }

      // 获取最后一条数据
      const lastRecord = this.tableData[this.tableData.length - 1];
      
      try {
        // 解析 checkClothInfo JSON
        const checkClothInfo = JSON.parse(lastRecord.checkClothInfo);
        const clothInfo = checkClothInfo.clothInfo || [];
        const clothInfoData = checkClothInfo.cloth_info || {};
        
        // 生成动态列
        const dynamicCols = [];
        
        // 1. 从 clothInfo 中找到 tag: true 的项目作为表头
        clothInfo.forEach(item => {
          if (item.tab === true) {
            const fieldName = item.field;
            const value = clothInfoData[fieldName] || '';
            
            dynamicCols.push({
              title: item.key,
              key: `cloth_${fieldName}`,
              width: 120,
              align: "center",
              render: (h, params) => {
                // 从每条记录的 checkClothInfo 中获取对应的值
                try {
                  const recordData = JSON.parse(params.row.checkClothInfo);
                  const recordClothInfo = recordData.cloth_info || {};
                  return h('span', recordClothInfo[fieldName] || '');
                } catch (e) {
                  return h('span', '');
                }
              }
            });
          }
        });
        
        // 2. 添加固定列
        const fixedCols = [
          {
            title: '长度(m)',
            key: 'length_m',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                const dist = recordData.dist || 0;
                return h('span', (dist / 1000).toFixed(2));
              } catch (e) {
                return h('span', '0.00');
              }
            }
          },
          {
            title: '长度(码)',
            key: 'length_yard',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                const dist = recordData.dist || 0;
                return h('span', (dist / 914.4).toFixed(2));
              } catch (e) {
                return h('span', '0.00');
              }
            }
          },
          {
            title: '宽度(cm)',
            key: 'width',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                return h('span', recordData.width || '');
              } catch (e) {
                return h('span', '');
              }
            }
          },
          {
            title: '疵点数量',
            key: 'flaw_count',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                const flawInfoList = recordData.flawInfoList || [];
                return h('span', flawInfoList.length);
              } catch (e) {
                return h('span', '0');
              }
            }
          },
          {
            title: '总扣分',
            key: 'deduct',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                return h('span', recordData.deduct || '0');
              } catch (e) {
                return h('span', '0');
              }
            }
          },
          {
            title: '百码扣分',
            key: 'hundred_deduct',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                return h('span', recordData.hundred_deduct || '0');
              } catch (e) {
                return h('span', '0');
              }
            }
          },
          {
            title: '评分等级',
            key: 'cloth_grade',
            width: 100,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                return h('span', recordData.cloth_grade || '');
              } catch (e) {
                return h('span', '');
              }
            }
          },
          {
            title: '上传时间',
            key: 'createTime',
            width: 180,
            align: "center",
            render: (h, params) => {
              return h('span', params.row.createTime || '');
            }
          },
          {
            title: '开始验布时间',
            key: 'start_check_time',
            width: 180,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                return h('span', recordData.start_check_time || '');
              } catch (e) {
                return h('span', '');
              }
            }
          },
          {
            title: '结束验布时间',
            key: 'end_check_time',
            width: 180,
            align: "center",
            render: (h, params) => {
              try {
                const recordData = JSON.parse(params.row.checkClothInfo);
                return h('span', recordData.end_check_time || '');
              } catch (e) {
                return h('span', '');
              }
            }
          }
        ];
        
        // 3. 操作列 - 下载验布报告
        const actionCol = {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let url = ''
            try {
              const recordData = JSON.parse(params.row.checkClothInfo)
              url = recordData.pdf_report_url || ''
            } catch (e) {
              url = ''
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'ios-download',
                  disabled: !url
                },
                on: {
                  click: () => {
                    if (url) {
                      window.open(url, '_blank')
                    }
                  }
                }
              }, '下载报告')
            ])
          }
        }
        
        // 4. 合并所有列
        this.columns = [
          { type: 'index', title: '序号', width: 80, align: "center" },
          ...dynamicCols,
          ...fixedCols,
          actionCol
        ];
        
      } catch (error) {
        console.error('解析 checkClothInfo 失败:', error);
        // 如果解析失败，使用默认列
        this.columns = [
          { type: 'index', title: '序号', width: 80, align: "center" },
          { title: "验布ID", key: "id", width: 100, align: "center" },
          { title: "验布时间", key: "createTime", width: 180, align: "center" }
        ];
      }
    }
  }
}
</script>

<style scoped>
.search-con {
  margin-bottom: 20px;
}

.page-con {
  margin-top: 20px;
}

.page-bottom {
  text-align: right;
}

/* 让 Card 高度充满视口，并让表格区域自适应剩余空间 */
.full-height-card {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}
.full-height-card :deep(.ivu-card-body) {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-body-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* 允许子元素在 flex 布局下正确滚动 */
}
.table-flex {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.page-con {
  margin-top: 12px;
}

/* 汇总信息样式 */
.summary-info {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.summary-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.summary-value {
  font-size: 14px;
  color: #1890ff;
  font-weight: 600;
}
</style>
